import { render } from "./TemplateListEdit.vue?vue&type=template&id=7bd7902a"
import script from "./TemplateListEdit.vue?vue&type=script&lang=js"
export * from "./TemplateListEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__